// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"c4c660da","217":"c4c660da"}[chunkId] + ".chunk.css";
};